import { ExtendedFields, FormPageState, Fqdn, parseFqdn } from '@wix/bex-core';
import { Tags } from '../components/Tags/types';
import { computed, makeObservable } from 'mobx';

export interface CairoEntityPageStateParams {
  fqdn: string;
}

export interface CairoEntityPageStateInterface {
  /**
   * Runs validation on all form fields.
   * Returns `isValid` to indicate the validation state for all fields,
   * if no validation error also return the validated `extendedFields` and `tags`.
   * */
  validate: () => Promise<{
    isValid: boolean;
    extendedFields?: ExtendedFields;
    tags?: Tags;
  }>;

  /**
   * Indicates the dirty state of existing form fields.
   */
  isDirty: boolean;
}

export interface CairoEntityPageWidgetState {
  validate: () => Promise<{ isValid: boolean }>;
  isDirty: boolean;
}

export class CairoEntityPageState implements CairoEntityPageStateInterface {
  fqdn: Fqdn;

  readonly formPage = new FormPageState();

  constructor(params: CairoEntityPageStateParams) {
    this.fqdn = parseFqdn(params.fqdn);

    makeObservable(this, {
      isDirty: computed,
    });
  }

  async validate() {
    const { isValid, data } = await this.formPage.validate();

    return {
      isValid,
      extendedFields: data.extendedFields,
      tags: data.tags,
    };
  }

  get isDirty() {
    return this.formPage.isDirty;
  }
}
